<template>
  <!-- Nav tabs -->
  <ul class="nav nav-tabs hidden-sm hidden-xs" :class="navClasses" data-init-reponsive-tabs="dropdownfx">
    <li v-for="(tab, index) in headings" @click.prevent="$emit('click', index)" :class="manageActiveClass(index)">
      <a aria-expanded="false"><span>{{ tab }}</span></a>
    </li>
  </ul>
</template>

<style>
.nav-tabs-fillup > li > a:after {
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    background: none repeat scroll 0 0 #fb557a;
    border: 1px solid #fb557a;
    content: "";
    height: calc(100% + 1px);
    left: 0;
    position: absolute;
    top: 0;
    transform: translate3d(0, 100%, 0px);
    transition: transform 0.3s ease 0s;
    width: 100%;
    z-index: -1;
}
</style>

<script type="text/babel">
  export default {

    props: {
      active: {
        type: Number,
        required: true
      },
      headings: {
        type: Array,
        required: true
      },
      navClasses: {
        type: Array,
        required: true
      }
    },

    methods: {
      manageActiveClass (index) {
        return { active: index === this.active }
      },
    },

  }
</script>



// WEBPACK FOOTER //
// client/components/Tabs/Navigation.vue